export default "__VITE_ASSET__CW9Xz$Gx__"